import { Disclosure, Transition } from '@headlessui/react'
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/20/solid'
import { useReducedMotion } from 'framer-motion'

import type { PropsWithChildren } from 'react'
import { classNames } from '~/utils/client/helpers'

type SectionProps = PropsWithChildren<{
  ident: string
  title: string
  className?: string
}>

export function AccordionSection({ title, children, className }: SectionProps) {
  const shouldReduceMotion = useReducedMotion()

  return (
    <Disclosure>
      {({ open }) => (
        <>
          <div className={classNames('w-full', className)}>
            <hr className="h-px bg-white/50 border-2 border-white" />
            <Disclosure.Button
              data-testid="accordion-section-button"
              className="w-full py-4 px-4 sm:px-6 md:px-8 flex items-center justify-between text-left text-black focus-visible:z-20"
            >
              <span className="min-w-0 flex-1 break-words pr-4 text-base font-normal leading-7">
                {title}
              </span>
              <span className="ml-6 flex h-7 items-center">
                {open ? (
                  <ChevronUpIcon className="h-6 w-6" aria-hidden="true" />
                ) : (
                  <ChevronDownIcon className="h-6 w-6" aria-hidden="true" />
                )}
              </span>
            </Disclosure.Button>
            <Transition
              className={classNames(
                'grid transition-[grid-template-rows,opacity] ease-in-out',
                shouldReduceMotion ? 'duration-0' : 'duration-300'
              )}
              enterFrom="grid-rows-[0fr] opacity-0"
              enterTo="grid-rows-[1fr] opacity-100"
              leaveFrom="grid-rows-[1fr] opacity-100"
              leaveTo="grid-rows-[0fr] opacity-0"
            >
              <div className="min-h-0 min-w-0 overflow-hidden">
                <Disclosure.Panel className="min-w-0 max-w-full w-full focus:outline-none">
                  {children}
                </Disclosure.Panel>
              </div>
            </Transition>
          </div>
        </>
      )}
    </Disclosure>
  )
}
